import { DocumentIcon, Signer } from "assets/icons";
import Chip from "components/chip/chip";
import useModal from "components/modal/useModal";
import { dateWordShort } from "helper/helper";
import UseContext from "hooks/useContext";
import ApiDatabase from "server";
import Tooltip from "../../tooltips/Tooltips";
import {useState, useEffect} from "react";
import TableCell from "./TableCell";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useScrollContext } from "./ScrollableTableWrapper";

const Tbodycontract = ({ champsBody }) => {
  const { toggle } = useModal();
  const { companyData, setSignatureLink, setDataYousign, setIdMission } = UseContext();
  const rUser = localStorage.getItem("rUser");
  const token = localStorage.getItem("xsrfToken");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState(null);
  const { hasMoved } = useScrollContext();

  // Récupérer l'ID depuis l'URL au chargement
  useEffect(() => {
    const idFromUrl = searchParams.get('selectedId');
    if (idFromUrl) {
      setSelectedId(idFromUrl);
      // Nettoyer l'URL après avoir récupéré l'ID
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('selectedId');
      const newUrl = newParams.toString() ? `?${newParams.toString()}` : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [searchParams]);

  const colorContract = {
    0: "ALERT",
    1: "INFO",
  };
  const contentContract = {
    0: "À signer",
    1: "Signé",
  };
  const openSignatureModal = (contract, missionId) => {
    // Ouvrir le modal immédiatement pour une meilleure UX
    toggle("doc_c_signature");

    // Faire l'appel API en arrière-plan
    ApiDatabase.postSignature(
      {
        id_mission: missionId,
        contract,
        token: localStorage.getItem("xsrfToken"),
      },
      (data) => {
        setDataYousign({
          yousign_id: data.pYousignId,
          contract_id: contract._id,
          mission_id: missionId,
        });
        setSignatureLink(data.pSignatureYousign);
      },
      (err) => {
        console.log(err);
        // Fermer le modal en cas d'erreur
        toggle("doc_c_signature");
      }
    );
  };

  const handleSign = (e, contract, item) => {
    e.preventDefault();
    e.stopPropagation();
    openSignatureModal(contract, item);
  };

  const handleRowClick = (item) => {
    // Empêcher le clic si on vient de faire un drag
    if (hasMoved) {
      return;
    }
    
    setSelectedId(item._id);
    
    // Vérifier si le contrat est à signer et si l'utilisateur peut signer
    const contract = item?.contract_company?.[0];
    if (contract && contract.status === "0" && rUser !== "200") {
      // Ouvrir le modal de signature
      openSignatureModal(contract, item?.id_mission);
    } else {
      // Naviguer vers la page de détail du contrat avec l'ID pour le retour
      const fileName = contract?.status === "1" 
        ? `contract_${item.id_mission}_company_signed`
        : `contract_${item.id_mission}_company`;
      const params = new URLSearchParams({
        missionId: item.id_mission,
        fileName: fileName,
        returnId: item._id,
        status: contract?.status || "0"
      });
      navigate(`/contract/detail?${params.toString()}`);
    }
  };

  const handleMissionCellClick = (e, item) => {
    e.stopPropagation();
    // Empêcher le clic si on vient de faire un drag
    if (hasMoved) {
      return;
    }
    setSelectedId(item._id);
    // Naviguer vers la page de la mission
    if (item?._id) {
      navigate(`/mission/${item._id}`);
    }
  };

  return (
    <>
      {champsBody.map((item, key) => {
        const isSelected = selectedId === item._id || selectedId === key;
        return (
        <tr 
          key={key} 
          className={`${isSelected ? 'bg-yellow-50' : 'hover:bg-gray-50'} cursor-pointer transition-colors`}
          onClick={() => handleRowClick(item)}
        >
          <td className={"py-5 pl-4 pr-2 min-w-[120px]"}>
            {item?.contract_company[0]?.id_bestt ?? null}
          </td>
          <td className={"py-5 px-2 min-w-[250px]"}>
            {item?.userCollection[0]?.firstname ?? null}{" "}
            {item.userCollection[0]?.lastname ?? null}
          </td>
          <td className={"py-5 px-2 min-w-[300px]"}>
            <Tooltip text="Voir la mission" placement="top">
              <div 
                className={`inline-flex gap-2 items-center px-2 py-1 rounded transition-colors cursor-pointer ${isSelected ? 'hover:bg-yellow-100' : 'hover:bg-gray-100'}`}
                onClick={(e) => handleMissionCellClick(e, item)}
              >
                <span className={'underline decoration-dashed'}>
                  {item?.title ?? null}
                </span>
              </div>
            </Tooltip>
          </td>
          <td className={"py-5 px-2"}>{item?.id_mission ?? null}</td>
          {item?.contract_company?.map((contract, key) => (
            <td key={key} className={"py-5 px-2 min-w-[100px]"}>
              <Chip type={"INDICATOR"} color={colorContract[contract.status]}>
                {contentContract[contract.status]}
              </Chip>
            </td>
          ))}
          {item?.contract_company?.map((contract, key) => (
            <td key={key} className={"py-5 px-2"}>
              {dateWordShort(contract.createdAt)}
            </td>
          ))}
          {item?.contract_company?.map((contract, key) => (
            <TableCell
              key={key}
              position="last"
              hasButton
              buttonOnClick={(e) => {
                e.preventDefault();
                    e.stopPropagation();
                if (contract.status === "0" && rUser !== "200") {
                    handleSign(e, contract, item?.id_mission);
                } else {
                  e.stopPropagation();
                  const fileName = contract.status === "1" 
                    ? `contract_${item.id_mission}_company_signed`
                    : `contract_${item.id_mission}_company`;
                  const params = new URLSearchParams({
                    missionId: item.id_mission,
                    fileName: fileName,
                    returnId: item._id,
                    status: contract.status || "0"
                  });
                  navigate(`/contract/detail?${params.toString()}`);
                }
                  }}
              buttonContent={
                contract.status === "0" && rUser !== "200" ? (
                  <Signer wh={24} />
              ) : (
                  <DocumentIcon wh={24} color={"#111827"} />
                )
              }
            />
          ))}
        </tr>
        );
      })}
    </>
  );
};

export default Tbodycontract;
